var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg183(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143,
    height: 143,
    viewBox: "0 0 143 143",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5627 89.3748H80.4377L77.0116 70.1592C78.9977 69.1662 80.5618 67.7262 81.7038 65.8394C82.8458 63.9526 83.4168 61.8672 83.4168 59.5832C83.4168 56.3061 82.25 53.5007 79.9163 51.167C77.5826 48.8333 74.7772 47.6665 71.5002 47.6665C68.2231 47.6665 65.4177 48.8333 63.084 51.167C60.7503 53.5007 59.5835 56.3061 59.5835 59.5832C59.5835 61.8672 60.1545 63.9526 61.2965 65.8394C62.4385 67.7262 64.0026 69.1662 65.9887 70.1592L62.5627 89.3748ZM71.5002 131.083C57.6967 127.607 46.3014 119.688 37.3142 107.324C28.3271 94.9608 23.8335 81.2318 23.8335 66.1373V29.7915L71.5002 11.9165L119.167 29.7915V66.1373C119.167 81.2318 114.673 94.9608 105.686 107.324C96.699 119.688 85.3036 127.607 71.5002 131.083ZM71.5002 118.571C81.8279 115.294 90.3682 108.739 97.121 98.9082C103.874 89.0769 107.25 78.1533 107.25 66.1373V37.9842L71.5002 24.578L35.7502 37.9842V66.1373C35.7502 78.1533 39.1266 89.0769 45.8793 98.9082C52.6321 108.739 61.1724 115.294 71.5002 118.571Z",
    fill: "url(#paint0_linear_3211_4256)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3211_4256",
    x1: 71.3007,
    y1: -48.294,
    x2: 71.3008,
    y2: 218.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8202D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg183);
export default __webpack_public_path__ + "static/media/svg183.35b36ea67843c7ab5377a46329f38b4c.svg";
export { ForwardRef as ReactComponent };